import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { DragDropContext, Draggable, Droppable, } from 'react-beautiful-dnd';
import { useTheme } from '@mui/material';
export function DragDropList({ items, onDragEnd, isDragDisabled, }) {
    const theme = useTheme();
    return (_jsx(DragDropContext, { onDragEnd: onDragEnd, children: _jsx(Droppable, { droppableId: "droppable", children: (provided, snapshot) => (_jsxs("div", { ...provided.droppableProps, ref: provided.innerRef, style: getListStyle(snapshot.isDraggingOver, theme.palette.mode === 'dark'), children: [items.map((item, index) => {
                        return (_jsx(Draggable, { draggableId: item.id, index: index, isDragDisabled: isDragDisabled, children: (provided, snapshot) => {
                                return (_jsx("div", { ref: provided.innerRef, ...provided.draggableProps, style: getItemStyle(snapshot, provided.draggableProps.style, theme.palette.mode === 'dark'), children: item.content(provided.dragHandleProps) }));
                            } }, item.id));
                    }), provided.placeholder] })) }) }));
}
// a little function to help us with reordering the result
export function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}
export function getItemStyle(snapshot, draggableStyle, is_dark_theme = false) {
    const styles = {
        boxShadow: snapshot.isDragging ? '0 0 10px rgba(0, 0, 0, 0.11111)' : 'none',
        backgroundColor: is_dark_theme ? '#424242' : 'white',
        ...draggableStyle,
    };
    if (snapshot.isDropAnimating) {
        return { ...styles, transitionDuration: '0.001s' };
    }
    if (!draggableStyle?.transform) {
        return styles;
    }
    return {
        ...styles,
        transform: `translate(0, ${draggableStyle?.transform.substring(draggableStyle?.transform.indexOf(',') + 1, draggableStyle?.transform.indexOf(')'))})`,
    };
}
export function getListStyle(isDraggingOver, is_dark_theme = false) {
    return {
        background: isDraggingOver ? 'lightblue' : is_dark_theme ? '#424242' : 'white',
    };
}
